/* ============================================================
   LUMÈRA — interactions (vanilla JS, no dependencies)
   Scroll reveal · FAQ accordion · Before/After slider ·
   UGC carousel · Sticky ATC · Countdown · Hero gallery · Qty
   ============================================================ */
(function () {
  "use strict";

  /* ---------- Scroll reveal ---------- */
  function initReveal(root) {
    var els = (root || document).querySelectorAll(".lumera-section .reveal:not([data-reveal-bound])");
    if (!("IntersectionObserver" in window)) {
      els.forEach(function (el) { el.classList.add("in"); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add("in"); io.unobserve(e.target); }
      });
    }, { threshold: 0.12, rootMargin: "0px 0px -60px 0px" });
    els.forEach(function (el) { el.setAttribute("data-reveal-bound", "1"); io.observe(el); });
  }

  /* ---------- FAQ accordion ---------- */
  function initFaq(root) {
    (root || document).querySelectorAll('[data-lumera-faq]:not([data-bound])').forEach(function (list) {
      list.setAttribute("data-bound", "1");
      list.querySelectorAll(".faq-item").forEach(function (item) {
        var q = item.querySelector(".faq-q");
        if (!q) return;
        q.addEventListener("click", function () {
          var isOpen = item.classList.contains("open");
          if (!list.hasAttribute("data-multi")) {
            list.querySelectorAll(".faq-item.open").forEach(function (o) { o.classList.remove("open"); });
          }
          item.classList.toggle("open", !isOpen);
        });
      });
    });
  }

  /* ---------- Before / After slider ---------- */
  function initBeforeAfter(root) {
    (root || document).querySelectorAll('[data-lumera-ba]:not([data-bound])').forEach(function (slider) {
      slider.setAttribute("data-bound", "1");
      var clip = slider.querySelector(".ba-clip");
      var handle = slider.querySelector(".ba-handle");
      var dragging = false;
      var pendingFrame = null;
      var lastX = null;

      function apply(pct) {
        pct = Math.max(2, Math.min(98, pct));
        if (clip) clip.style.clipPath = "inset(0 " + (100 - pct) + "% 0 0)";
        if (handle) handle.style.left = pct + "%";
      }
      function fromX(clientX) {
        var r = slider.getBoundingClientRect();
        if (!r.width) return;
        apply(((clientX - r.left) / r.width) * 100);
      }
      function schedule(clientX) {
        lastX = clientX;
        if (pendingFrame !== null) return;
        pendingFrame = requestAnimationFrame(function () {
          pendingFrame = null;
          fromX(lastX);
        });
      }
      function down(e) {
        dragging = true;
        slider.classList.add("dragging");
        if (e.type === "mousedown" && e.cancelable) e.preventDefault();
        var x = e.touches ? e.touches[0].clientX : e.clientX;
        schedule(x);
      }
      function move(e) {
        if (!dragging) return;
        var x = e.touches ? e.touches[0].clientX : e.clientX;
        schedule(x);
      }
      function up() {
        if (!dragging) return;
        dragging = false;
        slider.classList.remove("dragging");
      }

      slider.querySelectorAll("img").forEach(function (img) {
        img.setAttribute("draggable", "false");
        img.addEventListener("dragstart", function (ev) { ev.preventDefault(); });
      });

      slider.addEventListener("mousedown", down);
      slider.addEventListener("touchstart", down, { passive: true });
      window.addEventListener("mousemove", move);
      window.addEventListener("touchmove", move, { passive: true });
      window.addEventListener("mouseup", up);
      window.addEventListener("touchend", up);
      window.addEventListener("mouseleave", up);
      apply(50);
    });
  }

  /* ---------- UGC carousel + autoplay-in-view ---------- */
  function initUgc(root) {
    (root || document).querySelectorAll('[data-lumera-ugc]:not([data-bound])').forEach(function (stage) {
      stage.setAttribute("data-bound", "1");
      var track = stage.querySelector(".ugc-track");
      var prev = stage.querySelector(".ugc-nav.prev");
      var next = stage.querySelector(".ugc-nav.next");
      if (!track) return;
      function step(dir) {
        var card = track.querySelector(".ugc-card");
        var amt = card ? card.getBoundingClientRect().width + 18 : 320;
        track.scrollBy({ left: dir * amt, behavior: "smooth" });
      }
      function update() {
        if (prev) prev.disabled = track.scrollLeft < 4;
        if (next) next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 4;
      }
      if (prev) prev.addEventListener("click", function () { step(-1); });
      if (next) next.addEventListener("click", function () { step(1); });
      track.addEventListener("scroll", update, { passive: true });
      window.addEventListener("resize", update);
      update();

      var autoplay = stage.getAttribute("data-autoplay") === "true";
      var videos = stage.querySelectorAll("video.ugc-video");
      if (autoplay && videos.length && "IntersectionObserver" in window) {
        var vio = new IntersectionObserver(function (entries) {
          entries.forEach(function (e) {
            var v = e.target;
            if (e.isIntersecting && e.intersectionRatio >= 0.4) {
              var p = v.play();
              if (p && typeof p.catch === "function") p.catch(function () {});
            } else {
              v.pause();
            }
          });
        }, { threshold: [0, 0.4, 0.8] });
        videos.forEach(function (v) { v.muted = true; vio.observe(v); });
      } else if (videos.length) {
        videos.forEach(function (v) { v.muted = true; });
      }

      stage.querySelectorAll("[data-ugc-mute]").forEach(function (btn) {
        btn.addEventListener("click", function (ev) {
          ev.stopPropagation();
          var card = btn.closest(".ugc-card");
          var v = card && card.querySelector("video.ugc-video");
          if (!v) return;
          v.muted = !v.muted;
          btn.setAttribute("aria-pressed", v.muted ? "false" : "true");
          btn.classList.toggle("is-on", !v.muted);
          if (!v.muted) {
            var pr = v.play();
            if (pr && typeof pr.catch === "function") pr.catch(function () {});
          }
        });
      });

      stage.querySelectorAll(".ugc-card.has-video").forEach(function (card) {
        card.addEventListener("click", function (ev) {
          if (ev.target.closest("[data-ugc-mute]") || ev.target.closest(".ugc-nav")) return;
          var v = card.querySelector("video.ugc-video");
          if (!v) return;
          if (v.paused) {
            var pr = v.play();
            if (pr && typeof pr.catch === "function") pr.catch(function () {});
          } else { v.pause(); }
        });
      });
    });
  }

  /* ---------- Countdown ---------- */
  function initCountdown(root) {
    (root || document).querySelectorAll('[data-lumera-countdown]:not([data-bound])').forEach(function (el) {
      el.setAttribute("data-bound", "1");
      var hrs = parseInt(el.getAttribute("data-hours") || "11", 10);
      var mins = parseInt(el.getAttribute("data-minutes") || "23", 10);
      var secs = parseInt(el.getAttribute("data-seconds") || "47", 10);
      var target = Date.now() + ((hrs * 3600) + (mins * 60) + secs) * 1000;
      var nH = el.querySelector("[data-h]"), nM = el.querySelector("[data-m]"), nS = el.querySelector("[data-s]");
      function pad(n) { return String(n).padStart(2, "0"); }
      function tick() {
        var diff = Math.max(0, target - Date.now());
        if (nH) nH.textContent = pad(Math.floor(diff / 3600000));
        if (nM) nM.textContent = pad(Math.floor((diff % 3600000) / 60000));
        if (nS) nS.textContent = pad(Math.floor((diff % 60000) / 1000));
      }
      tick(); setInterval(tick, 1000);
    });
  }

  /* ---------- Hero media gallery + qty + sticky sync ---------- */
  function initHero(root) {
    (root || document).querySelectorAll('[data-lumera-hero]:not([data-bound])').forEach(function (hero) {
      hero.setAttribute("data-bound", "1");
      var hasSlideshow = !!hero.querySelector("[data-lumera-slideshow]");
      if (!hasSlideshow) {
        var main = hero.querySelector("[data-hero-main]");
        hero.querySelectorAll("[data-hero-thumb]").forEach(function (thumb) {
          thumb.addEventListener("click", function () {
            hero.querySelectorAll("[data-hero-thumb]").forEach(function (t) { t.classList.remove("active"); });
            thumb.classList.add("active");
            var src = thumb.getAttribute("data-src");
            if (!main || !src) return;
            if (main.tagName === "IMG") {
              var pre = new Image();
              pre.onload = function () { main.src = src; };
              pre.src = src;
              main.removeAttribute("srcset");
            } else {
              main.style.backgroundImage = "url('" + src + "')";
              main.style.backgroundSize = "cover";
              main.style.backgroundPosition = "center";
            }
          });
        });
      }
    });

    (root || document).querySelectorAll('[data-lumera-qty]:not([data-bound])').forEach(function (wrap) {
      wrap.setAttribute("data-bound", "1");
      var input = wrap.querySelector("input");
      var dec = wrap.querySelector("[data-qty-dec]");
      var inc = wrap.querySelector("[data-qty-inc]");
      function val() { return Math.max(1, parseInt(input.value || "1", 10)); }
      if (dec) dec.addEventListener("click", function () { input.value = Math.max(1, val() - 1); });
      if (inc) inc.addEventListener("click", function () { input.value = val() + 1; });
    });
  }

  /* ---------- Variant selection ----------
     Reads pre-formatted price strings (price_money / compare_money)
     from the variant JSON. These are emitted server-side via the
     `| money` Liquid filter so they already use the active Market's
     currency and symbol. We just stamp them in — no client-side
     formatting, no hard-coded €.
  */
  function initVariants(root) {
    (root || document).querySelectorAll('[data-lumera-variants]:not([data-bound])').forEach(function (form) {
      form.setAttribute("data-bound", "1");
      var data;
      try { data = JSON.parse(form.querySelector("[data-variant-json]").textContent); } catch (e) { return; }
      var idField = form.querySelector("[data-variant-id]");
      var selects = form.querySelectorAll("[data-option-index]");
      var priceEls = document.querySelectorAll("[data-lumera-price]");
      var compareEls = document.querySelectorAll("[data-lumera-compare]");
      var atcBtn = form.querySelector("[data-atc-btn]");

      function current() {
        var chosen = [];
        selects.forEach(function (sel) { chosen[parseInt(sel.getAttribute("data-option-index"), 10)] = sel.value; });
        return data.find(function (v) {
          return v.options.every(function (o, i) { return chosen[i] === undefined || o === chosen[i]; });
        });
      }
      function update() {
        var v = current();
        if (!v) {
          if (atcBtn) { atcBtn.disabled = true; atcBtn.textContent = "Unavailable"; }
          return;
        }
        if (idField) idField.value = v.id;
        if (atcBtn) { atcBtn.disabled = !v.available; }
        priceEls.forEach(function (el) {
          if (v.price_money) { el.textContent = v.price_money; }
        });
        compareEls.forEach(function (el) {
          if (v.compare_money && v.compare_at_price && v.compare_at_price > v.price) {
            el.textContent = v.compare_money;
            el.style.display = "";
          } else {
            el.style.display = "none";
          }
        });
      }
      selects.forEach(function (sel) { sel.addEventListener("change", update); });
      update();
    });
  }

  /* ---------- Sticky ATC ---------- */
  function initSticky(root) {
    (root || document).querySelectorAll('.lumera-sticky-atc:not([data-bound])').forEach(function (bar) {
      bar.setAttribute("data-bound", "1");
      var threshold = parseInt(bar.getAttribute("data-threshold") || "600", 10);
      function onScroll() { bar.classList.toggle("show", window.scrollY > threshold); }
      window.addEventListener("scroll", onScroll, { passive: true });
      onScroll();
      var btn = bar.querySelector("[data-sticky-add]");
      if (btn) btn.addEventListener("click", function () {
        var formId = bar.getAttribute("data-form") || "lumera-product-form";
        var form = document.getElementById(formId);
        if (form && form.requestSubmit) { form.requestSubmit(); }
        else if (form) { form.submit(); }
      });
    });
  }

  /* ---------- Toast ---------- */
  function initToast() {
    if (document.querySelector(".lumera-toast")) return;
    var toast = document.createElement("div");
    toast.className = "lumera-toast";
    toast.innerHTML = '<span class="ok">✓</span> <span class="lumera-toast-msg">Added to bag — your ritual begins this week.</span>';
    document.body.appendChild(toast);
    window.lumeraToast = function (msg) {
      if (msg) toast.querySelector(".lumera-toast-msg").textContent = msg;
      toast.classList.add("show");
      clearTimeout(window.__lumeraToastT);
      window.__lumeraToastT = setTimeout(function () { toast.classList.remove("show"); }, 2600);
    };
  }

  /* ---------- Generic add-to-bag triggers ---------- */
  function initAddTriggers(root) {
    (root || document).querySelectorAll('[data-lumera-add]:not([data-bound])').forEach(function (btn) {
      btn.setAttribute("data-bound", "1");
      btn.addEventListener("click", function () {
        var formId = btn.getAttribute("data-form") || "lumera-product-form";
        var form = document.getElementById(formId);
        if (!form) return;
        if (form.requestSubmit) { form.requestSubmit(); } else { form.submit(); }
      });
    });
  }

  /* ---------- Hero slideshow (multi-image gallery + swipe) ---------- */
  function initSlideshow(root) {
    (root || document).querySelectorAll('[data-lumera-slideshow]:not([data-bound])').forEach(function (sl) {
      sl.setAttribute("data-bound", "1");
      var main = sl.querySelector("[data-hero-main]");
      var thumbs = Array.prototype.slice.call(sl.querySelectorAll("[data-hero-thumb]"));
      var dots = Array.prototype.slice.call(sl.querySelectorAll("[data-slide-dot]"));
      var prevBtn = sl.querySelector("[data-slide-prev]");
      var nextBtn = sl.querySelector("[data-slide-next]");
      if (!main || !thumbs.length) return;

      var idx = 0;

      function show(i) {
        i = ((i % thumbs.length) + thumbs.length) % thumbs.length;
        idx = i;
        var src = thumbs[i].getAttribute("data-src");
        if (main.tagName === "IMG" && src) {
          var pre = new Image();
          pre.onload = function () { main.src = src; };
          pre.src = src;
          main.removeAttribute("srcset");
        } else if (src) {
          main.style.backgroundImage = "url('" + src + "')";
          main.style.backgroundSize = "cover";
          main.style.backgroundPosition = "center";
        }
        thumbs.forEach(function (t, j) { t.classList.toggle("active", j === i); });
        dots.forEach(function (d, j) { d.classList.toggle("active", j === i); });
        try { thumbs[i].scrollIntoView({ behavior: "smooth", inline: "nearest", block: "nearest" }); } catch (e) {}
      }

      thumbs.forEach(function (t, i) { t.addEventListener("click", function (e) { e.preventDefault(); show(i); }); });
      dots.forEach(function (d, i) { d.addEventListener("click", function (e) { e.preventDefault(); show(i); }); });
      if (prevBtn) prevBtn.addEventListener("click", function () { show(idx - 1); });
      if (nextBtn) nextBtn.addEventListener("click", function () { show(idx + 1); });

      var media = sl.querySelector(".hero-media");
      if (media) {
        var sx = 0, dx = 0, swiping = false;
        media.addEventListener("touchstart", function (e) {
          sx = e.touches[0].clientX; dx = 0; swiping = true;
        }, { passive: true });
        media.addEventListener("touchmove", function (e) {
          if (!swiping) return;
          dx = e.touches[0].clientX - sx;
        }, { passive: true });
        media.addEventListener("touchend", function () {
          if (!swiping) return;
          swiping = false;
          if (Math.abs(dx) > 40) { show(dx < 0 ? idx + 1 : idx - 1); }
        });
      }

      sl.setAttribute("tabindex", sl.getAttribute("tabindex") || "0");
      sl.addEventListener("keydown", function (e) {
        if (e.key === "ArrowLeft") { e.preventDefault(); show(idx - 1); }
        else if (e.key === "ArrowRight") { e.preventDefault(); show(idx + 1); }
      });
    });
  }

  /* ---------- Testimonial video reviews — push to play ---------- */
  function initTestimonialVideos(root) {
    (root || document).querySelectorAll('[data-lumera-tm-stage]:not([data-bound])').forEach(function (stage) {
      stage.setAttribute("data-bound", "1");

      stage.querySelectorAll(".tm-card.tiktok.has-video").forEach(function (card) {
        var v = card.querySelector("video.tt-video");
        if (!v) return;

        function play() {
          var p = v.play();
          if (p && typeof p.catch === "function") p.catch(function () {});
          card.classList.add("is-playing");
        }
        function pause() { v.pause(); card.classList.remove("is-playing"); }
        function toggle(ev) {
          ev.preventDefault();
          if (v.paused || v.ended) play(); else pause();
        }

        card.addEventListener("click", toggle);
        v.addEventListener("ended", function () { card.classList.remove("is-playing"); });
        v.addEventListener("pause", function () { card.classList.remove("is-playing"); });
        v.addEventListener("play", function () { card.classList.add("is-playing"); });

        if ("IntersectionObserver" in window) {
          var pio = new IntersectionObserver(function (entries) {
            entries.forEach(function (e) { if (!e.isIntersecting && !v.paused) v.pause(); });
          }, { threshold: 0 });
          pio.observe(v);
        }
      });
    });
  }

  function initAll(root) {
    initReveal(root); initFaq(root); initBeforeAfter(root); initUgc(root);
    initCountdown(root); initHero(root); initSlideshow(root); initVariants(root); initSticky(root); initAddTriggers(root);
    initTestimonialVideos(root);
  }

  document.addEventListener("DOMContentLoaded", function () { initToast(); initAll(document); });

  document.addEventListener("shopify:section:load", function (e) { initAll(e.target); });
  document.addEventListener("shopify:section:select", function (e) { initReveal(e.target); });
})();
